import { defaultPracticeSettings } from 'lib/constants/constants';
import { findOpenAndCloseClinicHours } from 'lib/helpers/workingHours';

export const buildCurrentPracticeState = (prev, { practice, child_practices }) => ({
  ...prev,
  id: practice.id,
  name: practice.name,
  email: practice.email,
  phone: practice.phone,
  address: practice?.practiceAddress?.fullAddress ?? '',
  header_photo: practice.header_photo,
  timezone: practice.timezone,
  display_settings: { ...defaultPracticeSettings, ...practice?.display_settings },
  working_hours: findOpenAndCloseClinicHours(practice?.available_times),
  appointment_types: practice?.appointment_types,
  care_credit: practice?.care_credit,
  surcharge_percentage: practice?.surcharge_percentage,
  surcharge_enabled: practice?.surcharge_enabled,
  socket_id: practice?.socket_id,
  no_show_fee: practice.no_show_fee,
  tax_id: practice?.tax_id,
  checkin_steps: practice?.checkin_steps,
  fax: practice?.fax,
  displayName: practice?.displayName,
  elab_orders: !!practice?.labsoft_cust_id,
  childPractices: child_practices,
  isMulti: child_practices?.length > 1,
  profession_group_id: practice?.profession_group_id,
  kind: practice?.kind,
  medbill_client: practice?.medbill_client
});
